import { render } from "./GradioAppBotSettings.vue?vue&type=template&id=e79ef070"
import script from "./GradioAppBotSettings.vue?vue&type=script&lang=js"
export * from "./GradioAppBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__